var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormHelperText = void 0;
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var React = __importStar(require("react"));
var Icon_1 = require("../Icon");
var FormHelperText_styles_1 = __importDefault(require("./FormHelperText.styles"));
exports.FormHelperText = React.forwardRef(function (props, ref) {
    var state = props.state, children = props.children, otherProps = __rest(props, ["state", "children"]);
    var classes = (0, FormHelperText_styles_1.default)({ state: state });
    var stateIconName = 'filled-default-mockup';
    if (state === 'error') {
        stateIconName = 'outlined-alert-cancel';
    }
    if (state === 'success') {
        stateIconName = 'outlined-alert-check';
    }
    return (React.createElement(FormHelperText_1.default, __assign({ className: classes.root, ref: ref }, otherProps),
        state && React.createElement(Icon_1.Icon, { className: classes.icon, name: stateIconName, size: "micro" }),
        children));
});
exports.FormHelperText.displayName = 'FormHelperText';
exports.default = exports.FormHelperText;
//# sourceMappingURL=FormHelperText.js.map